import Template from '../../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import SchoolIcon from '@mui/icons-material/School';
import ArrowForwardIcon from '@mui/icons-material/ForwardToInbox';
import ArrowForwardIcon2 from '@mui/icons-material/ArrowForward';
import UndoIcon from '@mui/icons-material/Undo';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import $ from 'jquery';
import { Download } from '@mui/icons-material';
export default function Admin_RecSignatureCourseList() {
const navigate = useNavigate();
const isAuth = useAuth();
if (isAuth === false) {
navigate("/college/");
}
const tableRef = useRef(null);
const [loading, setlodaing] = useState(false);
const { http } = Api();
const [courseData, setCourseData] = useState([]);
const [getSignatureCourseData, setSignatureCourseData] = useState([]);
const [getOtherSignatureCourseData, setOtherSignatureCourseData] = useState([]);
const [getCollegesData, setCollegesData] = useState([]);
const [getSpecializationsData, setSpecializationsData] = useState([]);
const [getDisciplinesData, setDisciplinesData] = useState([]);
const [getStatData, setStatData] = useState([]);
const [changedCollegeData, setChangedCollegeData] = useState(null);
const [changedCollegesId, setChangedCollegesId] = useState(null);
const [changedCollegeName, setChangedCollegeName] = useState(null);
const [changedSpecializationData, setChangedSpecializationData] = useState(null);
const [changedSpecializationId, setChangedSpecializationId] = useState(null);
const [changedDisciplineData, setChangedDisciplineData] = useState(null);
const [changedDisciplineId, setChangedDisciplineId] = useState(null);
const [changedStatusData, setChangedStatusData] = useState([]);
const [changedStatusId, setChangedStatusId] = useState([]);
const [principalForwardedCount, setPrincipalForwardedCount] = useState(0);
const [principalRevertedCount, setPrincipalRevertedCount] = useState(0);
const [principalverifPendCount, setPrincipalverifPendCount] = useState(0);
const [ACA16ForwardedToBOSCount, setACA16ForwardedToBOSCount] = useState(0);
const [searchClicked, setSearchClicked] = useState(false);
const [clearClicked, setClearClicked] = useState(false);
const [displayCollegeName, setDisplayCollegeName] = useState(false);
const [selectedAdmissionYearID, setSelectedAdmissionYearID] = useState([]);
const [selectedAdmissionYear, setSelectedAdmissionYear] = useState(null);
const [refresh, setrefresh] = useState(false);
/* CUSTOME DATA TABLE BEGAINS HERE */
const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
const [searchQuery, setSearchQuery] = useState('');
const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const [total_count, setTotal] = useState(null);
const [showCourseModal, setShowCourseModal] = useState(false);
const [selectedCourse, setSelectedCourse] = useState(null);
const [selectedItem, setSelectedItem] = useState(null);
const [showModal, setShowModal] = useState(false);
const [newRemark, setNewRemark] = useState('');
const [courseToForward, setCourseToForward] = useState({ id: null, course_type: null });
const [showCourseCodeModal, setShowCourseCodeModal] = useState(false);
const [getCourseCodeGeneration, setCourseCodeGeneration] = useState([]);
const [showReccModal, setShowReccModal] = useState(false);
const [fileNo, setFileNo] = useState('');
const [approvalDate, setApprovalDate] = useState('');
const [fileError, setFileError] = useState(false);
const [appdateError, setAppdateError] = useState(false);
const [showApprovalConfirmModal, setShowApprovalConfirmModal] = useState(false);
const [filenoError, setFilenoError] = useState(false);


const getStatusBadgeClass = (status) => {
const statusMap = {
'entered': 'bg-secondary',
'forwareded_to_principal': 'bg-info text-dark',
'teacher_submited': 'bg-primary',
'principal_forwarded': 'bg-success',
'principal_reverted': 'bg-warning text-dark',
'aca16_forwarded_to_bos': 'bg-info',
'aca16_reverted_to_teacher': 'bg-warning text-dark',
'coursecode_generated_by_aca12': 'bg-warning',
'final_approved_by_aca16': 'bg-success',
'bos_recommended_to_aca16': 'bg-info',
'bos_reverted_to_aca16': 'bg-danger',
'bos_rejected_course': 'bg-reject-txt'

};

return statusMap[status] || 'bg-secondary';
};
/* CUSTOME DATA TABLE ENDS HERE */
// for kebabmenu 12/3/2024
const [openKebabCourseId, setOpenKebabCourseId] = useState(null);
// Function to toggle the kebab menu for a specific row
const toggleKebabMenu = (courseId) => {
// Toggle the open state for the specified course ID
setOpenKebabCourseId(prevCourseId => (prevCourseId === courseId ? null : courseId));
};
// Close kebab menu when clicking anywhere on the screen -- 20/3/2024
useEffect(() => {
function handleClickOutside(event) {
// Check if any kebab menu is open
const isOpen = openKebabCourseId !== null;

// Check if click is outside kebab menu and any kebab menu is open
if (isOpen && !event.target.closest('.kebab-menu')) {
// Close the open kebab menu
setOpenKebabCourseId(null);
}
}
document.body.addEventListener('click', handleClickOutside);
return () => {
document.body.removeEventListener('click', handleClickOutside);
};
}, [openKebabCourseId]);
useEffect(() => {
const fetchSignatureCourseList = async () => {
const college_id = changedCollegesId ? changedCollegesId : 0;
const special_id = changedSpecializationId === undefined || changedSpecializationId === null ? '' : changedSpecializationId;
const discipline_id = changedDisciplineId ? changedDisciplineId : 0;
const entry_status = changedStatusId ? changedStatusId : 0;
setCourseData([]);
try {
const response = await http.get(`/Admin/aca12RecSignatureCourseList`, {
params: {
admission_year: selectedAdmissionYearID || null,
college_id: college_id,
specialisation_id: special_id,
discipline_id: discipline_id,
entry_status: entry_status,
}
});
setCourseData(response.data.data);
setSignatureCourseData(response.data.signature_course);
setOtherSignatureCourseData(response.data.other_signature_course);
if (response.data.data) {
if (college_id != 0 && college_id != null) {
setDisplayCollegeName(true);
}
else {
setDisplayCollegeName(false);
}
}
} catch (error) {
if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
toast.error("Invalid Token");
setTimeout(() => {
navigate("/admin/");
}, 5000);
} else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
toast.error(error.response.data.message);
} else {
toast.error(error.response.data.message);
}
}
};
fetchSignatureCourseList();
}, [refresh, searchClicked, clearClicked]);
useEffect(() => {
const college_id = changedCollegesId ? changedCollegesId : 0;
const fetchFiltersList = async () => {
try {
const response = await http.get('/Admin/aca12SignatureCourseListFilter', {
params: { college_id,fetchType:'bVoc' }
});
setCollegesData(response.data.colleges);                
// setSpecializationsData(response.data.specialisations);
const specialData = response.data.specialisations;
setDisciplinesData(response.data.disciplines);
setStatData(response.data.status);
if (!specialData || specialData.length === 0) {
setSpecializationsData([{ ugp_specialisation_id: "-1", ugp_specialisation_name: "No Specialization Course Added" }]);
}
else {
setSpecializationsData(response.data.specialisations);
}
} catch (error) {
if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
toast.error("Invalid Token");
setTimeout(() => {
navigate("/admin/");
}, 5000);
} else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
toast.error(error.response.data.message);
} else {
toast.error(error.response?.data?.message || "An error occurred.");
}
}
};
fetchFiltersList();
}, [navigate]);
useEffect(() => {
setSpecializationsData((prev) => {
const alreadyExists = prev.some(item => item.ugp_specialisation_id === 0);

if (!alreadyExists) {
return [...prev, { ugp_specialisation_id: 0, ugp_specialisation_name: "Other Signature Course" }];
}
return prev;
});
}, [getSpecializationsData]);
const handleadmissionyear = (selectedOptions) => {
setSelectedAdmissionYearID(selectedOptions.value);
setSelectedAdmissionYear(selectedOptions);
};
const handleCollegeChange = (selectedOption) => {
setChangedCollegeData(selectedOption);
setChangedCollegesId(selectedOption.value);
setChangedCollegeName(selectedOption.label);
};
const handleSpecializationChange = (selectedOption) => {
setChangedSpecializationData(selectedOption);
setChangedSpecializationId(selectedOption.value);
};
const handleDisciplineChange = (selectedOption) => {
setChangedDisciplineData(selectedOption);
setChangedDisciplineId(selectedOption.value);
};
const handleStatusChange = (selectedOption) => {
setChangedStatusData(selectedOption);
setChangedStatusId(selectedOption?.value || null);
};
const allStatusMap = {
final_approved_by_aca12: 'Final Approved by ACA12',
coursecode_generated_by_aca12: 'Course Code Generated by ACA12',
expert_committee_recommended_to_aca12: 'Expert Committee Recommended to ACA12',
};
const statusOptions = Object.entries(allStatusMap).map(([value, label]) => ({
value,
label
}));
const handleClearFields = () => {
setChangedCollegeData(null);
setChangedCollegesId(null);
setChangedCollegeName(null);
setChangedSpecializationData(null);
setChangedSpecializationId(null);
setChangedDisciplineData(null);
setChangedDisciplineId(null);
setChangedStatusData([]);
setChangedStatusId([]);
setSelectedAdmissionYearID([]);
setSelectedAdmissionYear(null);
setClearClicked(prev => !prev); // Toggle so useEffect triggers on every Clear click
}
const showCourseList = () => {
setSearchClicked(prev => !prev); // toggle to re-trigger useEffect
};
const getCourseDetails = async (id) => {
try {
const response = await http.get(`Admin/getSignatureCourseDetails`, {
params: { id }
});
setShowCourseModal(true);
const data = response.data;
setSelectedCourse({
courseid: data.id,
name: data.course_name,
semester: data.semester,
remarks: JSON.parse(data.remarks || '[]'),
status: data.entry_status
});
} catch (error) {
setShowCourseModal(false);

if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
toast.error("Invalid Token");
setTimeout(() => {
navigate("/college/");
}, 5000);
} else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
toast.error(error.response.data.message);
} else {
toast.error(error.response?.data?.message || "Something went wrong.");
}
}
};
const aca12ForwardToEC = async (id, ctype) => {
try {
const response = await http.get(`convenor/forwardCourseListByAca12ToExpert`, {
params: {
id: id,
course_type: ctype,
section_name: 'University(ACA12)',
action_name: 'Forwarded',
entry_status:'aca12_forwarded_to_expert_committee'

}
});
if (response?.data) {
toast.success("Forwarded successfully");
setOpenKebabCourseId(null);
setrefresh(prev => !prev);
}
} catch (error) {
setOpenKebabCourseId(null);
const res = error.response?.data;
if (res?.http_status === 403 && res.status_code === "ERR37") {
toast.error("Invalid Token");
setTimeout(() => {
navigate("/college/");
}, 5000);
} else if (res?.http_status === 429 && res.status_code === "ERR33") {
toast.error(res.message);
} else {
toast.error(res?.message || "An unexpected error occurred.");
}
}
};

const aca12RevertToTeacher = async (id, ctype) => {
try {
const response = await http.get(`convenor/forwardCourseListByAca12ToExpert`, {
params: {
id: id,
course_type: ctype,
section_name: 'University(ACA12)',
action_name: 'Reverted',
entry_status: 'aca12_reverted_to_teacher'

}
});
if (response?.data) {
toast.success("Reverted successfully");
setOpenKebabCourseId(null);
setrefresh(prev => !prev);
}
} catch (error) {
setOpenKebabCourseId(null);
const res = error.response?.data;
if (res?.http_status === 403 && res.status_code === "ERR37") {
toast.error("Invalid Token");
setTimeout(() => {
navigate("/college/");
}, 5000);
} else if (res?.http_status === 429 && res.status_code === "ERR33") {
toast.error(res.message);
} else {
toast.error(res?.message || "An unexpected error occurred.");
}
}
};

const setCourseRevert = async (courseid, status, remark) => {
if (!remark) {
toast.error("Please enter a remark");
return;
}
if (status === 'aca12_reverted_to_teacher') {

toast.error("This course is already reverted by the ACA12");
return;
}
try {
const response = await http.get(`Admin/revertCourseListForaca12`, {
params: {
id: courseid,
remark: remark,
section_name: 'University(ACA12)',
action_name: 'Reverted'
}
});
if (response?.data) {
toast.success("An email has been sent to corresponding Faculty");
toast.success("Course was reverted successfully");
setShowCourseModal(false);
setNewRemark('');
setrefresh(prev => !prev);
}
} catch (error) {
const res = error.response?.data;
if (res?.http_status === 403 && res.status_code === "ERR37") {
toast.error("Invalid Token");
setTimeout(() => {
navigate("/college/");
}, 5000);
} else if (res?.http_status === 429 && res.status_code === "ERR33") {
toast.error(res.message);
} else {
toast.error(res?.message || "An unexpected error occurred.");
}
}
};
const handleGeneratePDF = async (id, ctype) => {
setlodaing(true);
try {
const response = await http.get('/College/teacherSignatureCoursePreview', {
params: {
id: id,
course_type: ctype
},
responseType: 'blob',
});
if (response && response.data) {
// Create a URL for the downloaded file
const url = window.URL.createObjectURL(new Blob([response.data]));
const link = document.createElement('a');
link.href = url;
// Set the file name and download the PDF
link.setAttribute('download', `${localStorage.getItem('username')}_.pdf`);
document.body.appendChild(link);
link.click();
document.body.removeChild(link);
setlodaing(false);
return Promise.resolve('PDF generated successfully');
}
} catch (error) {
setlodaing(false);
console.error('Error generating PDF:', error);
return Promise.reject('Error generating PDF');
}
};

const handleCourseCodeGenertion = async () => {
try {
const { id, course_type } = courseToForward;

const response = await http.get(`Admin/aca12CourseCodeGeneration`, {
params: {
id: id,
course_type: course_type
}
});

if (response?.data) {
setCourseCodeGeneration(response.data.generated_courses || []);
toast.success("Course code(s) generated successfully.");
setrefresh(prev => !prev);

}
} catch (error) {

setCourseCodeGeneration([]);
const res = error.response?.data;

if (res?.http_status === 403 && res.status_code === "ERR37") {
toast.error("Invalid Token");
setTimeout(() => {
navigate("/admin/");
}, 5000);
} else if (res?.http_status === 429 && res.status_code === "ERR33") {
toast.error(res.message);
} else {
toast.error(res?.message || "An unexpected error occurred.");
}
}
};
const handleReccCancel = () => {

setCourseCodeGeneration([]);
setShowReccModal(false);
setShowCourseCodeModal(false);

setCourseToForward({ id: null, course_type: null });
setFileNo('');
setApprovalDate('');

setFileError(false);
setAppdateError(false);


}
/* CUSTOME DATA TABLE BEGAINS HERE */
const handleSearchInputChange = (event) => {
setSearchQuery(event.target.value);
};
const handleSort = (column) => {
const newSortBy = {
column,
direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
};
setSortBy(newSortBy);
};
const handleApprovalConfirm = () => {
let hasError = false;

if (!fileNo.trim()) {
setFileError(true);
hasError = true;
} else {
setFileError(false);
}

if (!approvalDate.trim()) {
setAppdateError(true);
hasError = true;
} else {
setAppdateError(false);
}

if (!hasError) {
setShowApprovalConfirmModal(true); // open confirmation modal
}
};
useEffect(() => {
const filteredAndSortedData = [...courseData].filter(courseDatas => {
return (
courseDatas.ugp_specialisation_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
courseDatas.course_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
courseDatas.discipline_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
courseDatas.admn_year?.toString().includes(searchQuery) ||
courseDatas.faculty_name?.toLowerCase().includes(searchQuery.toLowerCase())
);
}).sort((a, b) => {
if (sortBy.direction === 'asc') {
return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
} else {
return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
}
});
const itemsPerPage = 50;
const startIndex = (currentPage - 1) * itemsPerPage;
const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);
setfilteredAndSortedData(paginatedData);
setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
setTotal(filteredAndSortedData.length);
}, [searchQuery, sortBy, courseData, currentPage]);
const renderSortIcon = (columnName) => {
if (sortBy.column === columnName) {
return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
}
return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
};
const handleNextPage = () => {
if (currentPage < totalPages) {
setCurrentPage(currentPage + 1);
}
};
const handlePreviousPage = () => {
if (currentPage > 1) {
setCurrentPage(currentPage - 1);
}
};
const handlePageChange = (pageNumber) => {
setCurrentPage(pageNumber);
};
const getMaxDate = () => {
const today = new Date();
return today.toISOString().split('T')[0]; // YYYY-MM-DD
};
const aca12FinalApprove = async () => {    
try {
const { id, course_type } = courseToForward;
const response = await http.get(`Admin/forwardCourseListForAca12Approve`, {
params: {
id: id,
course_type: course_type,
file_no: fileNo,
approval_date: approvalDate
}
});    
if (response?.data) {
toast.success("Approved successfully");
setOpenKebabCourseId(null);
setShowReccModal(false);
setShowCourseCodeModal(false);
setCourseToForward({ id: null, course_type: null });
setFileNo('');
setApprovalDate('');
setFileError(false);
setAppdateError(false);
setrefresh(prev => !prev);
}
} catch (error) {
setOpenKebabCourseId(null);
setShowReccModal(false);
setShowCourseCodeModal(false);
setCourseToForward({ id: null, course_type: null });
setFileNo('');
setApprovalDate('');

setFileError(false);
setAppdateError(false);

const res = error.response?.data;
if (res?.http_status === 403 && res.status_code === "ERR37") {
toast.error("Invalid Token");
setTimeout(() => {
navigate("/admin/");
}, 5000);
} else if (res?.http_status === 429 && res.status_code === "ERR33") {
toast.error(res.message);
} else {
toast.error(res?.message || "An unexpected error occurred.");
}
}
};


const getMinDate = () => {
const date = new Date();
date.setMonth(date.getMonth() - 3);
return date.toISOString().split('T')[0];
};
/* CUSTOME DATA TABLE END HERE */
const customStyles = {
menu: (provided) => ({
...provided,
maxHeight: '200px',
overflowY: 'auto',
}),
menuList: (provided) => ({
...provided,
maxHeight: '200px',
overflowY: 'auto',
scrollbarWidth: 'thin',
scrollbarColor: '#888 #f1f1f1',
}),

/* Additional custom scrollbar styling for WebKit-based browsers */
multiValue: (provided) => ({
...provided,
'&::-webkit-scrollbar': {
width: '8px',
},
'&::-webkit-scrollbar-track': {
background: '#f1f1f1',
},
'&::-webkit-scrollbar-thumb': {
background: '#888',
borderRadius: '4px',
},
'&::-webkit-scrollbar-thumb:hover': {
background: '#555',
},
}),
};
// console.log(Name,selectedCourse);
return (
<>
<ToastContainer />
<Template>
{loading ? (
<div className="container-fluid">
<div className="row justify-content-center align-items-center">
<div className="col-sm-12">
<div className="card h-100">
<div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
<div className="containeranimate">
<div className="dot"></div>
<div className="dot"></div>
<div className="dot"></div>
<div className="dot"></div>
<div className="dot"></div>
<div className="dot"></div>
<div className="dot"></div>
<div className="dot"></div>
</div>
</div>
</div>
</div>
</div>
</div>
) : (
<div className="container-fluid">
<div className="row">
<div className="col-sm-12">
<div className="card">
<div className="col-md-12">
<div className="card-header">
<div className="py-3 d-flex justify-content-between align-items-center">
<h5>Signature Courses</h5>
</div>
</div>
<div className="card-body pdg">

<div className="card-body">
<div className="row">
<div className="col-md-2">
<label>Admission Year </label>
{/* <span className="errorclr">*</span> */}
<Select
maxMenuHeight={200}
menuPlacement="auto"
id="Adimission_year"
name="Adimission_year"
className="form"
styles={customStyles}
options={Array.from({length: new Date().getFullYear() - 2024}, (_, i) => ({
value: String(2025 + i),
label: String(2025 + i)
}))}
value={selectedAdmissionYear}
onChange={handleadmissionyear}
/>
</div>
<div className="col-md-3">
<label>College </label>
{/* <span className="errorclr">*</span> */}
<Select
maxMenuHeight={200}
menuPlacement="auto"
id="college_id"
name="college_id"
className="form"
styles={customStyles}
value={changedCollegeData}
options={getCollegesData && getCollegesData.map(college => ({
value: college.college_id,
label: college.college_name
}))}
onChange={handleCollegeChange}
/>
</div>

<div className="col-md-3">
<label>Specialization</label>
<Select
maxMenuHeight={200}
menuPlacement="auto"
id="specialization_id"
name="specialization_id"
className="form"
styles={customStyles}
value={changedSpecializationData}
options={getSpecializationsData && getSpecializationsData.map(spec => ({
value: spec.ugp_specialisation_id,
label: spec.ugp_specialisation_name.trim(),
isDisabled: spec.ugp_specialisation_id == -1
}))}
onChange={handleSpecializationChange}
/>
</div>

<div className="col-md-2">
<label>Discipline </label>
<Select
maxMenuHeight={200}
menuPlacement="auto"
id="discipline_id"
name="discipline_id"
className="form"
styles={customStyles}
value={changedDisciplineData}

options={getDisciplinesData && getDisciplinesData.map(discipline => ({
value: discipline.discipline_id,
label: discipline.discipline_name
}))}

onChange={handleDisciplineChange}
/>
</div>

<div className="col-md-2">

<label>Status</label>
<Select
maxMenuHeight={200}
menuPlacement="auto"
id="status_id"
name="status_id"
className="form"
styles={customStyles}
value={changedStatusData}
options={statusOptions}// Replace with actual options
onChange={handleStatusChange}
defaultValue=""
/>
</div>
<div className="col-md-12">
<div className="d-flex justify-content-end gap-2">
<button
type="button"
className="btn btn-primary action-btn"
onClick={showCourseList}
>
Go
</button>

<button
type="button"
className="btn btn-secondary clear-btn btn-sm"
onClick={handleClearFields}
>
Clear
</button>
</div>




</div>
</div>

</div>



<div className="card-body">
<div className="row">
<div className="col-md-12">
<div className="col-xxl-12 col-xl-12 box-col-12">

<div className="sig-heading">
<h6>
{displayCollegeName && (
<>
<b>Selected College</b>: {changedCollegeName}
</>
)}
</h6>


</div>

<div className="container">
<div className="table-responsive ovrflw" style={{ overflowX: 'auto' }}>
<div className="row justify-content-center">


<div className="col-md-10 stat-out-bod">
<h5 className="text-center mb-3">Course Statistics Overview</h5>

<table className="table-striped  table-bordered ex-table mb-10" ref={tableRef} id="dataTable" width="100%" style={{ textAlign: 'center', tableLayout: 'fixed' }}>
<thead>
<tr className="col-cnt-tab-bg-clr" style={{ height: '40px' }}>

<th colSpan="2" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>Signature Specialization Course</th>
<th colSpan="2" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>Other Signature Course</th>
</tr>
<tr style={{ height: '40px' }}>
<th>Pending</th>
<th>Approved</th>
<th>Pending</th>
<th>Approved</th>

</tr>
</thead>
<tbody>
<tr>

<td>{getSignatureCourseData.pending}</td>
<td>{getSignatureCourseData.Approved}</td>

<td>{getOtherSignatureCourseData.pending}</td>
<td>{getOtherSignatureCourseData.Approved}</td>


</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>

<div className="form theme-form">
<div className="custom-input">
{/* Add form inputs here */}

<div className="card-body">
<div className="card-body pdg1">
<div className="table-responsive">

<div className='row'>
<div className='col-md-6 wdt' >
<p>
Showing {(currentPage - 1) * 50 + 1}{''}-
{Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
</p>
</div>
<div className='col-md-6 wdt' align='right'>
<input
type="text"
value={searchQuery}
onChange={handleSearchInputChange}
placeholder="Search..."
className='form-control'
/></div></div>
<table className="display dataTable table-striped table-bordered ex-v-table" ref={tableRef}>
<thead>
<tr className="bg-primary">

<th onClick={() => handleSort('admn_year')} style={{ textAlign: "center", verticalAlign: "middle" }} >Admission Year &nbsp;
{renderSortIcon('admn_year')}</th>
<th onClick={() => handleSort('created_on')} style={{ textAlign: "center", verticalAlign: "middle" }} >Coordinator / Created On  &nbsp;
{renderSortIcon('created_on')}</th>
<th onClick={() => handleSort('discipline_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Discipline &nbsp;
{renderSortIcon('discipline_name')}</th>
<th onClick={() => handleSort('ugp_specialisation_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Specialisation &nbsp;
{renderSortIcon('ugp_specialisation_name')}</th>

<th onClick={() => handleSort('course_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Semester - Course Name &nbsp;
{renderSortIcon('course_name')}</th>

<th >Action &nbsp;</th>
</tr>
</thead>
<tbody>

{filteredAndSortedData && filteredAndSortedData.length > 0 ? (

filteredAndSortedData.map((item, index) => {

const serialNumber = (currentPage - 1) * 50 + index + 1;

return (
<tr key={item.id}>

<td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.admn_year}</td>
<td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.faculty_name} ({item.created_on})</td>
<td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.discipline_name}</td>
<td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.ugp_specialisation_name}</td>


{/* course names in <li> */}

<td style={{ textAlign: "left", verticalAlign: "middle" }}>
<div className="">
<ul className="course-list-li ps-3 mb-0">
{item.course_name?.split('|').map((course, idx) => {
const courseIds = item.id?.split('|') || [];
const courseId = courseIds[idx] || '';
const statuses = item.entry_status?.split('|') || [];
const rawStatus = statuses[idx]?.trim() || '';
const prinstatus = item.entry_status?.split('|')[idx]?.trim() || '';
const course_code = (item.course_code?.split('|')[idx] || '').trim();
let displayStatus = '';
switch (rawStatus) {
case 'entered':
    displayStatus = 'Draft';
    break;
case 'forwareded_to_principal':
    displayStatus = 'Forwarded to Principal';
    break;
case 'teacher_submited':
    displayStatus = 'Entry Completed';
    break;
case 'principal_forwarded':
    displayStatus = 'Principal Forwarded to ACA16';
    break;
case 'principal_reverted':
    displayStatus = 'Principal Reverted';
    break;
case 'aca16_forwarded_to_bos':
    displayStatus = 'ACA16 Forwarded to BOS';
    break;
case 'aca16_reverted_to_teacher':
    displayStatus = 'ACA16 Reverted to Teacher';
    break;
case 'coursecode_generated_by_aca12':
    displayStatus = 'Course Code Generated';
    break;
case 'final_approved_by_aca16':
    displayStatus = 'Approved';
    break;
case 'bos_recommended_to_aca16':
    displayStatus = 'BOS recommended to ACA16';
    break;
case 'bos_reverted_to_teacher':
    displayStatus = 'BOS Reverted to Teacher';
    break;
case 'bos_rejected_course':
    displayStatus = 'BOS Rejected';
    break;
case 'aca12_forwarded_to_expert_committee':
    displayStatus = 'ACA12 Forwarded to Expert Committee';
    break;
case 'aca12_reverted_to_teacher':
    displayStatus = 'ACA12 Reverted to Teacher';
    break;
case 'aca12_reverted_to_expert':
    displayStatus = 'ACA12 Reverted to Expert';
    break; 
case 'principal_forwarded_aca12':
    displayStatus = 'Principal Forwarded to ACA12';
    break;
case 'expert_committee_recommended_to_aca12':
    displayStatus = 'Recommended to ACA12';
    break;                   
default:
    displayStatus = rawStatus.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

const badgeClass = getStatusBadgeClass(rawStatus);

return (
<li
    key={idx}
    className="course-item-li"
    style={{ cursor: 'pointer' }}
    onClick={() => getCourseDetails(courseId)}
>
    <div className="pdg16">
        {course.trim()}
    </div>
    {course_code && course_code.length > 0 && (
        <div className="pdg16" style={{ fontWeight: '500', border: '1px solid #54ba4a', borderRadius: '7px' }}>
            {course_code}
        </div>
    )}
    <div className="pdg17">
        <span className={`badge ${badgeClass}`} style={{ fontSize: '0.8rem' }}>
            {displayStatus}
        </span>
    </div>
    {prinstatus === 'principal_forwarded_aca12' && (
        <div>
            <i
                className="fa fa-rotate-left text-primary plus-icon"
                aria-hidden="true"
                title="Add Remarks and Revert to Faculty"
                style={{ cursor: 'pointer', fontSize: '1.2rem' }}
            ></i>

        </div>
    )}

</li>


);
})}
</ul>
</div>
</td>
{/* course names in <li> End */}

<td style={{ textAlign: "center", verticalAlign: "middle" }}>
<div className="kebab-menu position-relative">
{item.entry_status && (
<div className="d-flex gap-2">                                                                                                        {(() => {
const statuses = item.entry_status?.split('|').map(s => s.trim()) || [];
const allExpertCommitteeRecommended = statuses.length > 0 && statuses.every(s => s === 'expert_committee_recommended_to_aca12');
const notDraftFile = statuses.length > 0 && statuses.every(s => s !== 'entered');
    const allCourseCodeGeneratedByACA12 = statuses.length > 0 && statuses.every(s => s === 'coursecode_generated_by_aca12');
const courseIds = item.id;
return (
    <>
        {allExpertCommitteeRecommended && (
            <div className="icon-button1 coursecode-button approve-icon"
                onClick={() => {
                    setCourseToForward({ id: courseIds, course_type: item.course_type });
                    setShowCourseCodeModal(true);
                }}
                title='Course Code Generation'>
                <i className="bi bi-book text-success" title='Course Code Generation'></i>

            </div>
        )}
        {allCourseCodeGeneratedByACA12 && (
            <div className="icon-button1 forward-button approve-icon"
                onClick={() => {
                    setCourseToForward({ id: courseIds, course_type: item.course_type });
                    setShowReccModal(true);
                }}
                title='Final Approve'>
                <i className="bi bi-check2-square text-success" title='Final Approve'></i>
            </div>
        )}
            {notDraftFile && (
            <div className="icon-button1 download-button" title='Download PDF' onClick={() => handleGeneratePDF(item.id, item.course_type)}>
                <i className="bi bi-download" title='Download PDF'></i>
            </div>
        )} 
    </>

);
})
()}

</div>
)}
</div>
</td>

</tr>
)
})
) : (
<tr>
<td colSpan="7" className="text-center py-3">No Data Found</td>
</tr>
)}
</tbody>
</table>
</div>

{/* //pagination logic  */}

{totalPages > 1 && (
<nav aria-label="..." style={{ cursor: "pointer" }}>
<ul className="pagination justify-content-center">
<li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
<span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
</li>
<li className={`page-item`}>
<span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
</li>
{currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
{[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
<li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
<span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
</li>
))}
{currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

<li className={`page-item`}>
<span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
</li>

<li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
<span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
</li>
</ul>
</nav>
)}
</div>
</div>
{showCourseModal && (
<div className="modal-backdrop" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.3)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1050 }}>

<div
className="modal-content"
style={{
width: '500px',
maxWidth: '95%',
maxHeight: '90vh',
display: 'flex',
flexDirection: 'column',
backgroundColor: '#f8f9fa',
borderRadius: '8px',
border: '1px solid #dee2e6',
boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
}}
>
<div className="modal-header" style={{ padding: '1rem', borderBottom: '1px solid #dee2e6', backgroundColor: '#e9ecef', position: 'sticky', top: 0, zIndex: 1 }}>
<h5 className="modal-title m-0" style={{ color: '#495057', fontSize: '1.1rem' }}>
<i className="bi bi-book me-2"></i>Course Details
</h5>
<button
type="button"
className="btn-close"
onClick={() => setShowCourseModal(false)}
aria-label="Close"
/>
</div>
<div
className="modal-body p-0 activity-scroll-container activity-scroll-bar-container clg-card-ht "
style={{ overflowY: 'auto', flex: 1 }}
>
{selectedCourse && (
<table className="table table-bordered m-0">
<tbody>
<tr>
<td style={{ width: '30%', backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Course Name</td>
<td style={{ wordBreak: 'break-word', padding: '0.75rem' }}>{selectedCourse.name}
<input type="hidden" name="courseid" id="courseid" value={selectedCourse.courseid} />
</td>
</tr>
<tr>
<td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Semester</td>
<td style={{ wordBreak: 'break-word' }}>{selectedCourse.semester}</td>
</tr>
<tr>

<td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Remarks</td>
<td style={{ wordBreak: 'break-word' }}>
<div style={{ border: '1px solid #b0b1b3', padding: '10px' }}>

{selectedCourse.remarks.length > 0 ? (
<ul className="mb-0 ps-3" style={{ listStyleType: 'disc' }}>
{selectedCourse.remarks.map((r, idx) => (
<li key={idx}>
<strong>{r.name}</strong> <em className="text-muted" style={{ fontSize: '0.85em' }}>({r.timestamp})</em><br />
{r.remark}
</li>
))}
</ul>
) : 'N/A'}
</div>
</td>
</tr>
<tr>
<td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Add Remark</td>

<td>
<textarea
name="remark"
id="remark"
className="form-control"
rows="3"
placeholder="Enter your remark here..."
onChange={(e) => setNewRemark(e.target.value)}
value={newRemark}
/>
</td>
</tr>
<tr>
<td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Status</td>
<td style={{ wordBreak: 'break-word' }}>
<div
className={`badge ${getStatusBadgeClass(selectedCourse.status)}`}
style={{ fontSize: '0.9rem', padding: '0.4em 0.6em' }}
>
{{
entered: 'Draft',
forwareded_to_principal: 'Forwarded to Principal',
teacher_submited: 'Entry Completed',
principal_forwarded_aca12: 'Principal Forwarded to ACA12',
principal_reverted: 'Principal Reverted',
aca16_forwarded_to_bos: 'ACA16 Forwarded to BOS',
aca16_reverted_to_teacher: 'ACA16 Reverted to Teacher',
coursecode_generated_by_aca12: 'Course Code Generated',
final_approved_by_aca16: 'Final Approved by ACA16',
bos_recommended_to_aca16: 'BOS Recommended to ACA16',
bos_reverted_to_aca16: 'BOS Reverted to ACA16',
}[selectedCourse.status] ||
selectedCourse.status
.split('_')
.map(word => word.charAt(0).toUpperCase() + word.slice(1))
.join(' ')}
</div>
</td>
</tr>
</tbody>
</table>
)}
</div>

<div className="modal-footer" style={{ padding: '0.75rem 1rem', borderTop: '1px solid #dee2e6', backgroundColor: '#e9ecef', position: 'sticky', bottom: 0 }}>

{selectedCourse && selectedCourse.status === 'principal_forwarded_aca12' && (
<button
type="button"
className="btn btn-sm btn-danger"
title="Revert to Faculty"

onClick={() => setCourseRevert(selectedCourse.courseid, selectedCourse.status, newRemark)}
>
<i className="bi bi-arrow-counterclockwise me-1"></i> Revert
</button>
)}
<button type="button" className="btn btn-sm btn-outline-secondary"
onClick={() => setShowCourseModal(false)}
>
<i className="bi bi-x-lg me-1"></i> Close
</button>
</div>
</div>
</div>
)}
{showCourseCodeModal && (
<>
<div className="custom-modal-backdrop"></div>

<div className="custom-modal-wrapper">
<div className="custom-modal-container col-md-7">
<div className="custom-modal-content p-4">
{(getCourseCodeGeneration.length == 0 || getCourseCodeGeneration === '') && (
<h5 className="text-center">Are you sure you want to generate course codes for the selected course(s)? <br />This action cannot be undone.
</h5>
)}




{getCourseCodeGeneration.length > 0 && (
<>
<h5 className="text-center">Generated Course Codes</h5>
<div className="fin-app-box">
<div className="mt-3">
<table className="table table-bordered table-sm m-b-30 table-striped ex-v-table">
<thead className="table-light">
<tr>
<th>Course Name</th>
<th>Allotted Course Code</th>
</tr>
</thead>
<tbody>
{getCourseCodeGeneration.map((course, index) => (
<tr key={index}>
<td>{course.course_name}</td>
<td>{course.course_code}</td>
</tr>
))}
</tbody>
</table>
</div>

</div>
</>
)}

<div className="d-flex justify-content-center mt-3">
{getCourseCodeGeneration.length === 0 && (
<button
className="btn btn-primary mx-2 btn-zoom-hover"
onClick={handleCourseCodeGenertion}
>
Generate
</button>
)}

<button
className="btn btn-zoom-hover"
style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
onClick={handleReccCancel}
>
{getCourseCodeGeneration.length > 0 ? 'Close' : 'Cancel'}
</button>
</div>
</div>
</div>
</div>
</>
)}

{showReccModal && (
<>
<div className="custom-modal-backdrop"></div>

<div className={`custom-modal-wrapper ${showApprovalConfirmModal ? 'blur-background' : ''}`}>
<div className="custom-modal-container col-md-7">
<div className="custom-modal-content p-4">
<h4 className="text-center">
Approve Course(s)
</h4>

<div className="fin-app-box">


<div className="row align-items-center m-t-20">
<label className="col-sm-3 col-form-label">File/Order No.</label>
<div className="col-sm-9">
<input
type="text"
className="form-control input-air-primary"
placeholder="Enter File No."
value={fileNo}
onChange={(e) => setFileNo(e.target.value)}
/>
{filenoError && (
<span className="text-danger small">Please enter File/Order No.</span>
)}
</div>
</div>

<div className="row align-items-center">
<label className="col-sm-3 col-form-label">Approved Date</label>
<div className="col-sm-9">
<input
type="date"
className="form-control input-air-primary"
value={approvalDate}
onChange={(e) => setApprovalDate(e.target.value)}
min={getMinDate()}
max={getMaxDate()} // today
/>
{appdateError && (
<span className="text-danger small">Please Select Approval date.</span>
)}
</div>
</div>
</div>


<div className="d-flex justify-content-center mt-3">
<button
className="btn btn-primary mx-2 btn-zoom-hover"
onClick={handleApprovalConfirm}
>
Proceed
</button>

<button
className="btn btn-zoom-hover"
style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
onClick={handleReccCancel}
>
Cancel
</button>
</div>
</div>
</div>
</div>
</>
)}


{showApprovalConfirmModal && (
<>
<div className="custom-modal-backdrop"></div>
<div className="custom-modal-wrapper">
<div className="custom-modal-container col-md-5">
<div className="custom-modal-content p-4 text-center">
<h6 className="mb-3">This is an irreversible action, and the recommended course(s) will be moved to "Approved" status.</h6>
{/* <p className="text-muted small">
This is an irreversible action, and the recommended course(s) will be moved to "Approved" status.
</p> */}

<div className="d-flex justify-content-center gap-3 mt-4">
<button
className="btn btn-success btn-sm btn-zoom-hover"
onClick={() => {
setShowApprovalConfirmModal(false);
aca12FinalApprove();
}}
>
Approve
</button>
<button
className="btn btn-outline-danger btn-sm btn-zoom-hover"
onClick={() => setShowApprovalConfirmModal(false)}
>
Cancel
</button>
</div>
</div>
</div>
</div>
</>
)}

</div>
</div>

</div>
</div>
</div>
</div>
</div>
</div>
)}
</Template >
</>
);
}
